import axios from "axios";
import { UserConfig } from "./user_config";

const axiosApiInstance = axios.create();
// const httpEndpoint = "http://59.148.100.40:8001";
const httpEndpoint = `${process.env.REACT_APP_BACKEND_ENDPOINT}:${process.env.REACT_APP_BACKEND_PORT}`;
const userConfig = new UserConfig();

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    config.headers = {
      //   Authorization: `Bearer ${getAccessToken()}`,
      Accept: "application/json",
      // "Content-Type": "application/x-www-form-urlencoded",
      "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      //   const accessToken = await refreshAccessToken(getAccessToken());
      //   console.log("accessToken");
      //   console.log(accessToken);
      //   axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

const accountCreate = async ({
  username,
  password,
  nickname,
  emailAddress,
}) => {
  const response = axiosApiInstance.post(
    `${httpEndpoint}/api/v1/user/register`,
    {
      username,
      // password: sha512(password),
      nickname,
      emailAddress,
    }
  );
  return (await response).data;
};

const send_messageApi = async ({ message }) => {
  const response = axiosApiInstance.post(
    `${httpEndpoint}/api/v1/project/send_message`,
    {
      message,
    }
  );
  return (await response).data;
};

const getAudio = async ({ uid }) => {
  // const response = axiosApiInstance.get(
  //   `${httpEndpoint}/api/v1/project/audio?uid${uid}`
  // );
  const audio = new Audio(`${httpEndpoint}/api/v1/project/audio?uid=${uid}`);
  return await audio;
  // var endpoint = "http://.0.0.0:8001/api/stream";
  // var url =
  //   endpoint + "?path=" + path + "&filename=" + filename + "&seed=" + genUID();
  // var audio = new Audio(url);
};

const getLocalWeatherApi = async () => {
  const dataType = "flw";
  const req = axiosApiInstance.get(
    `https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=${dataType}&lang=${userConfig.hkoLang}`
  );
  return (await req).data;
};
const getFutureWeatherApi = async () => {
  const dataType = "fnd";
  const req = axiosApiInstance.get(
    `https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=${dataType}&lang=${userConfig.hkoLang}`
  );
  return (await req).data;
};

const getWeatherReportApi = async () => {
  const dataType = "rhrread";
  const req = axiosApiInstance.get(
    `https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=${dataType}&lang=${userConfig.hkoLang}`
  );
  return (await req).data;
};

const getWarningSummaryApi = async () => {
  const dataType = "warnsum";
  const req = axiosApiInstance.get(
    `https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=${dataType}&lang=${userConfig.hkoLang}`
  );
  return (await req).data;
};

const getWarningInfoApi = async () => {
  const dataType = "warningInfo";
  const req = axiosApiInstance.get(
    `https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=${dataType}&lang=${userConfig.hkoLang}`
  );
  return (await req).data;
};

const getWeatherTipsApi = async () => {
  const dataType = "swt";
  const req = axiosApiInstance.get(
    `https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=${dataType}&lang=${userConfig.hkoLang}`
  );
  return (await req).data;
};

const getNewsApi = async () => {
  const req = axiosApiInstance.get(
    `https://rthk9.rthk.hk/rthk/news/rss/c_expressnews_clocal.xml`
  );
  return (await req).data;
};

const getYoutubeInfoApi = async ({ url }) => {
  // https://www.youtube.com/oembed?url=https://youtu.be/mnnzZKbsrqM&format=json
  // {
  //     "title": "KBoxx【無廣告】(经典老歌500首大全 )一人一首成名曲50首國語懷舊經典金曲 - 沒有你陪伴真的好孤單 「目前為止最好聽版本」难忘经典老歌100首 - 70、80、90年代经典老歌尽在 经典老歌",
  //     "author_name": "Kenn Boxx 中文歌曲 82.8K subscribers",
  //     "author_url": "https://www.youtube.com/@kennboxx82.8ksubscribers2",
  //     "type": "video",
  //     "height": 113,
  //     "width": 200,
  //     "version": "1.0",
  //     "provider_name": "YouTube",
  //     "provider_url": "https://www.youtube.com/",
  //     "thumbnail_height": 360,
  //     "thumbnail_width": 480,
  //     "thumbnail_url": "https://i.ytimg.com/vi/mnnzZKbsrqM/hqdefault.jpg",
  //     "html": "<iframe width=\"200\" height=\"113\" src=\"https://www.youtube.com/embed/mnnzZKbsrqM?feature=oembed\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" allowfullscreen title=\"KBoxx【無廣告】(经典老歌500首大全 )一人一首成名曲50首國語懷舊經典金曲 - 沒有你陪伴真的好孤單 「目前為止最好聽版本」难忘经典老歌100首 - 70、80、90年代经典老歌尽在 经典老歌\"></iframe>"
  //   }
  const req = axiosApiInstance.get(
    `https://www.youtube.com/oembed?url=${url}&format=json`
  );
  return (await req).data;
};

export {
  getAudio,
  getLocalWeatherApi,
  getFutureWeatherApi,
  getWeatherReportApi,
  getWarningSummaryApi,
  getWarningInfoApi,
  getWeatherTipsApi,
  getYoutubeInfoApi,
  getNewsApi,
  send_messageApi,
};
